import React, { Component } from "react";
import { CAMPAIGN_CONTACT_LIST_API, CAMPAIGN_CONTACT_LIST_API_2 } from "../../../constants/ServiceConstants";
import api from "../../../axios/Axios";
import DashboardLayout from "../../UI/Layout/DashboardLayout";
import AdvanceDataTable from "../../UI/Table/AdvanceDataTable";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faEye, faTrashAlt, faUpload } from '@fortawesome/free-solid-svg-icons';
import Alert from "../../UI/Alert/Alert";
import { Link } from "react-router-dom";
import { downloadContactList, NODE_HOST_URL } from "../api/Api";
import DeleteModal from "../campaign/Rcs/DeleteModal";
import { CAMPAIGN_FILTER_CONTACT_LIST } from "../../UI/Table/ColumnConst";
import Axios from "../../../axios/Axios";
import styles from "./ContactList.module.css";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import { handleUserLog } from "../../Utils/Utils";

class ContactList extends Component {

  constructor() {
    const lStorage = JSON.parse(localStorage.getItem("login"));
    const user_id = lStorage.user.userId;
    const token = lStorage.token;
    super();

    this.state = {
      userId: user_id,
      token: token,
      ContactListData: [],
      setIsLoading: true,
      searchDataTable: false,
      filterContact: '',
      isError: false,
      messageType: '',
      errorMessage: '',
      showDeletePopup: false,
      deleteId: '',
      showEditModal: false,
      editData: null,
      assignType: '',
      selectedTeam: '',
      selectedAgent: [],
      teamAgents: [],
      teamList: [],
      agentList: [],
      agentId: [],
      allAgentsMap: {}, // Map to store agent id to agent name mapping
      isLoadingAgents: false,

    };
  }

  customTableStyles = {
    rows: {
      style: {
        minHeight: '48px',
      }
    },
    headCells: {
      style: {
        background: '#3f3966',
        color: '#fff',
        padding: '10px 12px',
        fontWeight: '600',
        fontSize: '13px',
      },
    },
    cells: {
      style: {
        color: '#2d2d2d',
        lineHeight: '1.5',
        padding: '8px 12px',
        fontSize: '13px',
      },
    },
    table: {
      style: {
        width: '100%',
        tableLayout: 'fixed',
      },
    },
    tableWrapper: {
      style: {
        width: '100%',
      },
    },
  };

  componentDidMount() {
    this.getWhatsaAppNumberList();
    this.fetchAllAgents();
  }

  fetchAllAgents = async () => {
    this.setState({ isLoadingAgents: true });

    const lStorage = JSON.parse(localStorage.getItem("login"));

    const payload = {
      user_id: lStorage.user.parent_id || this.state.userId,
      method: "retrieve_agent",
      token: lStorage.user.parent_token || this.state.token,
      user_type: "client",
      agent_id: this.state.userId,
    };

    try {
      const response = await fetch(`${NODE_HOST_URL}/whatsapp_agent`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await response.json();

      if (data.success === true && Array.isArray(data.data)) {
        const agents = data.data.filter(
          (agent) => agent.agent_type === "agent"
        );
        const teams = data.data.filter(
          (agent) => agent.agent_type === "team"
        );

        // Create a map of agent id to agent name for quick lookup
        const agentsMap = {};
        data.data.forEach(agent => {
          agentsMap[agent.id] = agent.name;
        });

        this.setState({
          agentList: agents,
          teamList: teams,
          allAgentsMap: agentsMap,
          isLoadingAgents: false,
        });
      } else {
        this.setState({
          agentList: [],
          teamList: [],
          allAgentsMap: {},
          isLoadingAgents: false,
        });
      }
    } catch (error) {
      console.log('Error fetching agents:', error);
      this.setState({ isLoadingAgents: false });
    }
  };

  getWhatsaAppNumberList = async () => {
    try {
      const { data } = await api.post(CAMPAIGN_CONTACT_LIST_API_2, {
        token: this.state.token,
        user_id: this.state.userId,
        method: "retrieve",
      });
      //console.log(data);
      if (data.success === true) {
        let filterData = data.data.filter(x => x.status === 1)
        this.setState({ ContactListData: filterData, setIsLoading: false });
      } else {
        this.setState({ errorMessage: data.message, isError: true, messageType: 'alert-danger', setIsLoading: false });
      }
    } catch (err) {
      console.log(err);
    }
  };

  filterData = async () => {
    this.setState({ isError: false })
    try {
      const { data } = await api.post(CAMPAIGN_CONTACT_LIST_API, {
        token: this.state.token,
        user_id: this.state.userId,
        method: "filter",
        mobile: this.state.filterContact
      });
      if (data.success === true) {
        let filterData = data.data.filter(x => x.status === 1)
        this.setState({ ContactListData: filterData, setIsLoading: false, searchDataTable: true });
      } else {
        this.setState({ errorMessage: data.message, isError: true, messageType: 'alert-danger', setIsLoading: false });
      }
    } catch (err) {
      console.log(err);
    }
  };

  resetFilter = () => {
    this.getWhatsaAppNumberList();
    this.setState({
      searchDataTable: false,
      filterContact: '',
    })
  }

  openEditModal = (row) => {
    console.log('Editing row:', row);
    console.log("Existing agent IDs raw:", row.agent_ids);
    console.log("Agent IDs type:", typeof row.agent_ids);

    // Parse agent IDs from the row data - handle multiple formats
    let agentIds = [];
    if (row.agent_ids !== null && row.agent_ids !== undefined && row.agent_ids !== '') {
      if (Array.isArray(row.agent_ids)) {
        console.log('Processing as array');
        agentIds = row.agent_ids.map(id => parseInt(id)).filter(id => !isNaN(id));
      } else if (typeof row.agent_ids === 'string') {
        console.log('Processing as string');
        console.log('String before processing:', row.agent_ids);

        // Check if it's a JSON array string like "[1182,1098]"
        if (row.agent_ids.startsWith('[') && row.agent_ids.endsWith(']')) {
          try {
            const parsed = JSON.parse(row.agent_ids);
            if (Array.isArray(parsed)) {
              console.log('Parsed as JSON array:', parsed);
              agentIds = parsed.map(id => parseInt(id)).filter(id => !isNaN(id));
            }
          } catch (e) {
            console.log('JSON parsing failed, using fallback');
            // If JSON parsing fails, remove brackets and split by comma
            const cleanStr = row.agent_ids.replace(/[\[\]]/g, '');
            agentIds = cleanStr.split(',').map(id => parseInt(id.trim())).filter(id => !isNaN(id));
          }
        } else {
          // Try different separators: comma, semicolon, pipe
          let splitIds = [];
          if (row.agent_ids.includes(',')) {
            splitIds = row.agent_ids.split(',');
          } else if (row.agent_ids.includes(';')) {
            splitIds = row.agent_ids.split(';');
          } else if (row.agent_ids.includes('|')) {
            splitIds = row.agent_ids.split('|');
          } else {
            splitIds = [row.agent_ids]; // Single value
          }
          console.log('After split:', splitIds);
          agentIds = splitIds.map(id => parseInt(id.trim())).filter(id => !isNaN(id));
        }
      } else if (typeof row.agent_ids === 'number') {
        console.log('Processing as number');
        agentIds = [parseInt(row.agent_ids)];
      } else {
        console.log('Unknown format, trying to convert:', row.agent_ids);
        // Try to convert whatever it is to string first
        const str = String(row.agent_ids);
        agentIds = str.split(',').map(id => parseInt(id.trim())).filter(id => !isNaN(id));
      }
    }

    console.log('Final parsed agent IDs:', agentIds);

    this.setState({
      showEditModal: true,
      editData: row,
      agentId: row.agent_ids || [],
      selectedAgent: agentIds.map(String),
      assignType: agentIds.length > 0 ? 'agent' : '',
    });
  };

  closeEditModal = () => {
    this.setState({
      showEditModal: false,
      editData: null,
      assignType: '',
      selectedTeam: '',
      selectedAgent: [],
      teamAgents: [],
      agentId: []
    });
  };

  handleTeamSelect = (teamId) => {
    const { teamList, agentList } = this.state;
    const selectedTeam = teamList.find((team) => team.id === parseInt(teamId));
    const teamAgents = agentList.filter(
      (agent) => agent.team_name === selectedTeam?.name
    );

    this.setState({
      selectedTeam: teamId,
      teamAgents: teamAgents,
      selectedAgent: [],
    });
  };

  // Remove this method as we're handling it in openEditModal now
  saveAgentAssignment = async () => {
    if (!this.state.editData || !this.state.selectedAgent.length) {
      alert('Please select at least one agent');
      return;
    }

    this.setState({ setIsLoading: true });

    const payload = {
      method: "update_list",
      list_id: this.state.editData.id,
      selected_agent: this.state.selectedAgent,
      user_id: this.state.userId,
      token: this.state.token
    };

    try {
      const response = await fetch(`https://console.authkey.io/api/contact-list.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (data.success) {
        this.setState({
          errorMessage: "Agent assignment updated successfully",
          isError: true,
          messageType: "alert-success",
        });

        handleUserLog(
          "",
          "update_agent",
          "contact_list",
          data.message,
          "contact_list",
          "",
          {
            contact_list_id: this.state.editData.id,
            selected_agent: this.state.selectedAgent
          }
        );

        this.closeEditModal();
        this.getWhatsaAppNumberList(); // refresh
        setTimeout(() => this.setState({ isError: false }), 4000);
      } else {
        this.setState({
          errorMessage: data.message || "Failed to update agent assignment",
          isError: true,
          messageType: "alert-danger",
        });
        handleUserLog(
          "",
          "update_agent_failed",
          "contact_list",
          data.message,
          "contact_list",
          "",
          {
            contact_list_id: this.state.editData.id,
            selected_agent: this.state.selectedAgent
          }
        );
      }

    } catch (error) {
      this.setState({
        errorMessage: "Error updating agent assignment",
        isError: true,
        messageType: "alert-danger",
      });
      handleUserLog(
        "",
        "update_agent_error",
        "contact_list",
        error.message,
        "contact_list",
        "",
        {
          contact_list_id: this.state.editData.id,
          selected_agent: this.state.selectedAgent
        }
      );
    } finally {
      this.setState({ setIsLoading: false });
    }
  };

  DeleteContactListDetails = (id) => {
    this.setState({ showDeletePopup: true, deleteId: id })
  }

  DeleteContactList = async () => {
    this.setState({ setIsLoading: true })
    try {
      let paramData = {
        token: this.state.token,
        user_id: this.state.userId,
        method: "delete",
        id: this.state.deleteId
      }
      let { data } = await Axios.post(CAMPAIGN_CONTACT_LIST_API, paramData)
      if (data.success) {
        this.setState({ errorMessage: data.message, isError: true, messageType: 'alert-success', showDeletePopup: false });
        handleUserLog(
          "",
          "deleted_contact_list",
          "contact_list",
          data.message,
          "contact_list",
          "",
          {
            contact_list_id: this.state.deleteId
          }
        );
        this.getWhatsaAppNumberList();
        setTimeout(() => {
          this.setState({ isError: false })
        }, 4000)
      }
      else {
        this.setState({ errorMessage: data.message, isError: true, messageType: 'alert-danger', showDeletePopup: true });
        handleUserLog(
          "",
          "deleted_contact_list_failed",
          "contact_list",
          data.message,
          "contact_list",
          "",
          {
            contact_list_id: this.state.deleteId
          }
        );
      }
    } catch (error) {
      this.setState({ errorMessage: error.message, isError: true, messageType: 'alert-danger', showDeletePopup: true });
      handleUserLog(
        "",
        "deleted_contact_list_error",
        "contact_list",
        error.message,
        "contact_list",
        "",
        {
          contact_list_id: this.state.deleteId
        }
      );
    }
    finally {
      this.setState({ setIsLoading: false })
    }
  }

  getAssignedAgentNames = (agentIds) => {
    const { allAgentsMap } = this.state;

    if (!agentIds) return "None";

    // Handle different data formats
    let ids = [];

    if (Array.isArray(agentIds)) {
      ids = agentIds.map(id => parseInt(id)).filter(id => !isNaN(id));
    } else if (typeof agentIds === 'string' && agentIds.trim() !== '') {
      // Check if it's a JSON array string like "[1182,1098]"
      if (agentIds.startsWith('[') && agentIds.endsWith(']')) {
        try {
          const parsed = JSON.parse(agentIds);
          if (Array.isArray(parsed)) {
            ids = parsed.map(id => parseInt(id)).filter(id => !isNaN(id));
          }
        } catch (e) {
          // If JSON parsing fails, fallback to comma split
          const cleanStr = agentIds.replace(/[\[\]]/g, '');
          ids = cleanStr.split(',').map(id => parseInt(id.trim())).filter(id => !isNaN(id));
        }
      } else {
        // Handle comma, semicolon, or pipe separated values
        let splitIds = [];
        if (agentIds.includes(',')) {
          splitIds = agentIds.split(',');
        } else if (agentIds.includes(';')) {
          splitIds = agentIds.split(';');
        } else if (agentIds.includes('|')) {
          splitIds = agentIds.split('|');
        } else {
          splitIds = [agentIds];
        }
        ids = splitIds.map(id => parseInt(id.trim())).filter(id => !isNaN(id));
      }
    } else if (typeof agentIds === 'number') {
      ids = [parseInt(agentIds)];
    }

    if (ids.length === 0) return "None";

    const names = ids
      .map((id) => allAgentsMap[id] || `Agent-${id}`)
      .filter(Boolean);

    return names.length ? names.join(", ") : "None";
  };



  CAMPAIGN_CONTACT_LIST = [
    {
      name: "List ID",
      selector: (row) => row.id,
      sortable: true,
      width: '16.66%',
      minWidth: '70px'
    },
    {
      name: "Contact List",
      cell: (e) => (
        <div style={{ overflow: 'hidden', width: '100%' }}>
          <div style={{ fontWeight: '600', color: '#1a1a2e', fontSize: '13px', lineHeight: '1.4', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{e.name} ({e.list_type})</div>
          {e.description && (
            <div style={{ fontSize: '12px', color: '#888', lineHeight: '1.4', marginTop: '2px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{e.description}</div>
          )}
        </div>
      ),
      sortable: true,
      width: '16.66%'
    },
    {
      name: "Total",
      cell: (e) => (
        <span className={styles.countBadge}>{e.number_count}</span>
      ),
      sortable: true,
      width: '16.66%',
      center: true,
    },
    {
      name: "Assigned Agents",
      cell: (e) => {
        const names = this.getAssignedAgentNames(e.agent_ids);
        return names === "None" ? (
          <span className={styles.noAgentChip}>Unassigned</span>
        ) : (
          <div className={styles.agentCell} title={names}>{names}</div>
        );
      },
      sortable: false,
      width: '16.66%'
    },
    {
      name: "Status",
      cell: (e) => (
        e.status === 0
          ? <span className={styles.statusInactive}>Inactive</span>
          : <span className={styles.statusActive}>Active</span>
      ),
      sortable: true,
      width: '16.66%',
      center: true,
    },
    {
      name: "Actions",
      cell: (e) => (
        <div className={styles.actionGroup}>
          <Link
            to={`upload-contact-list/${e.id}/${e.list_type}/${encodeURIComponent(e.name ?? "")}`}
            title="Upload Contacts"
            className={`${styles.actionBtn} ${styles.actionBtnGreen}`}
            onClick={() => {
              handleUserLog(
                "",
                "upload_contact_list",
                "contact_list",
                "User clicked on Upload Contact List button",
                "contact_list",
                "",
                {
                  contact_list_id: e.id,
                  contact_list_name: e.name,
                  list_type: e.list_type
                }
              );
            }}
          >
            <FontAwesomeIcon icon={faUpload} />
          </Link>
          <Link
            to={`view-contact-list/${e.id}/${e.list_type}/${encodeURIComponent(e.name ?? "")}`}
            title="View Contacts"
            className={`${styles.actionBtn} ${styles.actionBtnPurple}`}
          >
            <FontAwesomeIcon icon={faEye} />
          </Link>
          <button
            onClick={() => downloadContactList(e.id, e.list_type)}
            title="Download"
            className={`${styles.actionBtn} ${styles.actionBtnGreen}`}
          >
            <FontAwesomeIcon icon={faDownload} />
          </button>
          <button
            onClick={() => this.DeleteContactListDetails(e.id)}
            title="Delete"
            className={`${styles.actionBtn} ${styles.actionBtnRed}`}
          >
            <FontAwesomeIcon icon={faTrashAlt} />
          </button>
          <button
            onClick={() => this.openEditModal(e)}
            title="Edit Agents"
            className={`${styles.actionBtn} ${styles.actionBtnOrange}`}
          >
            <FontAwesomeIcon icon={faEdit} />
          </button>
        </div>
      ),
      width: '16.66%',
    },
  ];

  render() {
    return (
      <DashboardLayout>
        <main className="content">
          <div className="container-fluid p-0">

            {/* Page Header */}
            <div className={styles.pageHeader}>
              <div>
                <h4 className={styles.pageTitle}>Campaign Contact List</h4>
                <p className={styles.pageSubtitle}>Create and manage contact lists for your campaigns</p>
              </div>
              <Link to="/dashboard/create-contact-list" className={styles.createBtn}>
                + Create New Contact List
              </Link>
            </div>

            {/* Alert */}
            {this.state.isError && (
              <div className={styles.alertSection}>
                <Alert type={this.state.messageType}>{this.state.errorMessage}</Alert>
              </div>
            )}

            {/* Table */}
            <div className={styles.tableCard}>
              {!this.state.searchDataTable ? (
                <AdvanceDataTable
                  tableName={"Contact list"}
                  tableCell={this.CAMPAIGN_CONTACT_LIST}
                  tableData={this.state.ContactListData}
                  isLoading={this.state.setIsLoading}
                  isError={this.state.ErrorResponse}
                  containerClass={styles.fullWidthTable}
                  customStyles={this.customTableStyles}
                  pagination={true}
                  paginationPerPage={50}
                />
              ) : (
                <AdvanceDataTable
                  tableName={`Search Results: ${this.state.filterContact}`}
                  tableCell={CAMPAIGN_FILTER_CONTACT_LIST}
                  tableData={this.state.ContactListData}
                  isLoading={this.state.setIsLoading}
                  isError={this.state.ErrorResponse}
                  containerClass={styles.fullWidthTable}
                  customStyles={this.customTableStyles}
                  pagination={true}
                  paginationPerPage={50}
                />
              )}
            </div>

          </div>

          <DeleteModal
            show={this.state.showDeletePopup}
            onClose={() => this.setState({ showDeletePopup: false })}
            onDelete={this.DeleteContactList}
          />

          {this.state.showEditModal && (
            <div className={styles.modalOverlay}>
              <div className={styles.modalBox}>

                <div className={styles.modalHeader}>
                  <div>
                    <h5 className={styles.modalTitle}>Edit Assigned Agents</h5>
                    <p className={styles.modalSubtitle}>{this.state.editData?.name}</p>
                  </div>
                  <button className={styles.modalClose} onClick={this.closeEditModal}>×</button>
                </div>

                <div className={styles.modalBody}>
                  {this.state.isLoadingAgents ? (
                    <div className={styles.loadingCenter}>
                      <div className="spinner-border text-primary" role="status" />
                      <p className={styles.loadingText}>Loading agents...</p>
                    </div>
                  ) : (
                    <>
                      <div className={styles.assignedInfo}>
                        <span className={styles.assignedLabel}>Currently Assigned</span>
                        <span className={styles.assignedValue}>
                          {this.getAssignedAgentNames(this.state.editData?.agent_ids)}
                        </span>
                      </div>

                      <div className={styles.formGroup}>
                        <label className={styles.formLabel}>Assign To</label>
                        <select
                          className={styles.formSelect}
                          value={this.state.assignType}
                          onChange={(e) =>
                            this.setState({
                              assignType: e.target.value,
                              selectedTeam: "",
                              selectedAgent: [],
                              teamAgents: [],
                            })
                          }
                        >
                          <option value="">Select type</option>
                          <option value="agent">Agent</option>
                          <option value="team">Team</option>
                        </select>
                      </div>

                      {this.state.assignType === "team" && (
                        <div className={styles.formGroup}>
                          <label className={styles.formLabel}>Select Team</label>
                          <select
                            className={styles.formSelect}
                            onChange={(e) => this.handleTeamSelect(e.target.value)}
                          >
                            <option value="">Select a team</option>
                            {this.state.teamList.map((team) => (
                              <option key={team.id} value={team.id}>{team.name}</option>
                            ))}
                          </select>
                        </div>
                      )}

                      {(this.state.assignType === "agent" ||
                        (this.state.assignType === "team" && this.state.teamAgents.length > 0)) && (
                          <div className={styles.formGroup}>
                            <label className={styles.formLabel}>Select Agents</label>
                            <Select
                              isMulti
                              value={(() => {
                                const selectedIds = this.state.selectedAgent.map(String);
                                return selectedIds
                                  .map(id => {
                                    const agent = this.state.agentList.find(a => String(a.id) === id) ||
                                      this.state.teamAgents.find(a => String(a.id) === id);
                                    return agent ? { value: String(agent.id), label: agent.name } : null;
                                  })
                                  .filter(Boolean);
                              })()}
                              options={(this.state.assignType === "team"
                                ? this.state.teamAgents
                                : this.state.agentList
                              ).map((agent) => ({
                                value: String(agent.id),
                                label: agent.name,
                              }))}
                              onChange={(selected) => {
                                console.log('Select onChange:', selected);
                                this.setState({
                                  selectedAgent: selected ? selected.map((s) => String(s.value)) : [],
                                });
                              }}
                              placeholder="Select agents..."
                              classNamePrefix="select"
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  borderRadius: "8px",
                                  borderColor: "#d1d5db",
                                  boxShadow: "none",
                                  minHeight: "40px",
                                }),
                                multiValue: (base) => ({
                                  ...base,
                                  backgroundColor: "#ede9f8",
                                }),
                                multiValueLabel: (base) => ({
                                  ...base,
                                  color: "#3f3966",
                                }),
                              }}
                            />
                          </div>
                        )}
                    </>
                  )}
                </div>

                <div className={styles.modalFooter}>
                  <button className={styles.btnSecondary} onClick={this.closeEditModal}>
                    Cancel
                  </button>
                  <button
                    className={styles.btnPrimary}
                    onClick={this.saveAgentAssignment}
                    disabled={!this.state.selectedAgent.length}
                  >
                    Save Changes
                  </button>
                </div>

              </div>
            </div>
          )}

        </main>
      </DashboardLayout>
    );
  }
}

export default ContactList;
